// export const XUANAPI = `http://10.145.198.172:8080/einvoice-api/api/v1/eInvoice`; //UAT
// export const XUANAPI = `http://10.145.195.124:8080/einvoice-api/api/v1/eInvoice`; // Xuan PC
// export const XUANAPI = `https://portal.prudential.com.vn/einvoice-api/api/v1/eInvoice`; // Portal
export const XUANAPI = `https://apigateway.prudential.com.vn/openapi/partner/einvoice-api/api/v1/eInvoice`; // Production
